
//Create pipette instance
export const createPipette = (data) => {
    //data = {id, type}
    return { type: "CREATE_PIPETTE", payload: data }
}

//Increases volume by some amount
export const incVol = (data) => {
    //data = {id}
    return { type: "INC_VOL", payload: data}
}

//Decreases volume by some amount
export const decVol = (data) => {
    //data = {id}
    return { type: "DEC_VOL", payload: data}

}

//Set volume by some amount
export const setVol = (data) => {
    //data = {id, volume}
    return { type: "SET_PIPETTE_VOL", payload: data}
}

//Change tip attached status
export const setTipAttached = (data) => {
    //data = {id, attached}
    return { type: "SET_TIP_ATTACHED", payload: data}
}

//Change tip used status
export const setTipUsed = (data) => {
    //data = {id, used}
    return { type: "SET_TIP_USED", payload: data}
}

//Set solution in current tip
export const setPipetteSolution = (data) => {
    //data = {id, solution}
    return { type: "SET_PIPETTE_SOLUTION", payload: data}
}

//Set if pipette controls are visible or not
export const setHeld = (data) => {
    //data = {id, held}
    return { type: "SET_HELD", payload: data}
}

//Set if pipette plunger is being depressed or not
export const setAnimatingOut = (data) => {
    //data = {id, animatingOut}
    return { type: "SET_PIPETTE_ANIMATING_OUT", payload: data}
}

//Set whether the pipette controls are displayed or not
export const setPipetteControlVisibility = (data) => {
    //data = {id, animatingOut}
    return { type: "SET_PIPETTE_CONTROLS_VISIBLE", payload: data}
}

//Set the current pipette plunger state
export const setPlungerPosition = (data) => {
    //data = {id, currentPlunger}
    return { type: "SET_PIPETTE_PLUNGER_POSITION", payload: data}
}

//Set the current pipette plunger position in px
export const setCurrentPlungerPos = (data) => {
    //data = {id, currentPlungerPos}
    return { type: "SET_PIPETTE_CURRENT_PLUNGER_POSITION", payload: data}
}
